import InfoIcon from "@material-ui/icons/Info";
import React from "react";
import PropTypes from "prop-types";
import Tooltip from "@material-ui/core/Tooltip";
import withStyles from "@material-ui/core/styles/withStyles";

import lightTooltipStyle from "assets/EnergyCompany/jss/lightTooltip";

const styles = theme => ({
  ...lightTooltipStyle(theme),
  tooltipWrapper: {
    ...lightTooltipStyle(theme).tooltipContentWrapper,
    alignItems: "flex-end",
  },
  tooltipContent: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    "& span": {
      marginLeft: "15px",
    },
  },
});

const UsinaTooltip = ({ classes, shouldShow, title }) => (
  shouldShow ? (
    <Tooltip
      classes={{ popper: classes.lightTooltipPopper, tooltip: classes.lightTooltip }}
      placement="top"
      title={
        <div className={classes.tooltipContent}>
          <h4><b>Não estamos considerando:</b></h4>
          <span>MRGF/fator de disponibilidade (exceto usinas sem GF definida)</span>
          <span>Perdas internas (usinas fora do MRE)</span>
          <span>A sazonalização das usinas (usinas fora do MRE)</span>
          <span>O fator de capacidade máxima e nem o índice de disponibilidade verificado (usinas não hidráulicas sem GF definida com despacho IA ou IIA)</span>
        </div>
      }
    >
      <span className={classes.tooltipWrapper}>
        {title} <InfoIcon />
      </span>
    </Tooltip>
  ) : title
);

UsinaTooltip.propTypes = {
  classes: PropTypes.object.isRequired,
  shouldShow: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};

export default withStyles(styles)(UsinaTooltip);



// WEBPACK FOOTER //
// ./src/views/Dashboard/partials/UsinaTooltip.jsx